import React from 'react';
import { Link } from 'react-router-dom'; // Make sure to import Link from react-router-dom

const ServiceTwo = () => {
  return (
    <section className="service-two">
      <div className="container">
        <div className="row">
          <div className="col-xl-8 col-lg-8 wow fadeInLeft" data-wow-delay="100ms">
            <div className="service-two__left">
              <div className="section-title text-left">
                <div className="section-title__tagline-box">
                  <span className="section-title__tagline">
                  WHAT WE DO</span>
                </div>
                <h2 className="section-title__title">
                Services <span>We Offer</span>
                </h2>
              </div>
              <p className="service-two__text">
                Roof service involves the installation, maintenance, and repair of roofs for the
                <br /> residential and commercial buildings. The contractors offer a range
              </p>
              <div className="service-two__view-all">
                <Link to="#">View All Service<span className="icon-dubble-arrow-right"></span></Link>
              </div>
            </div>
          </div>

          {/* Services Two Single Start */}
          <div className="col-xl-4 col-lg-4 wow fadeInRight" data-wow-delay="200ms">
            <div className="service-two__single">
              <div className="service-two__icon-and-title">
                <div className="service-two__icon">
                  <span className="icon-buildings"></span>
                </div>
                <div className="service-two__title">
                  <Link to="/managed-it-services">Managed IT Services</Link>
                </div>
              </div>
              <p className="service-two__single-text">
                Managed IT solutions are designed to be there around the clock to ensure companies market
              </p>
              <div className="service-two__read-more">
                <Link to="/managed-it-services">Read more<span className="icon-dubble-arrow-right"></span></Link>
              </div>
            </div>
          </div>
          {/* Services Two Single End */}

          {/* Services Two Single Start */}
          <div className="col-xl-4 col-lg-4 wow fadeInLeft" data-wow-delay="300ms">
            <div className="service-two__single">
              <div className="service-two__icon-and-title">
                <div className="service-two__icon">
                  <span className="icon-tools"></span>
                </div>
                <div className="service-two__title">
                  <Link to="/security-consulting">Security Consulting</Link>
                </div>
              </div>
              <p className="service-two__single-text">
               Security Consulting to address IT Security requirements across Network consulting services
              </p>
              <div className="service-two__read-more">
                <Link to="/security-consulting">Read more<span className="icon-dubble-arrow-right"></span></Link>
              </div>
            </div>
          </div>
          {/* Services Two Single End */}

          {/* Services Two Single Start */}
          <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="400ms">
            <div className="service-two__single">
              <div className="service-two__icon-and-title">
                <div className="service-two__icon">
                  <span className="icon-crane-1"></span>
                </div>
                <div className="service-two__title">
                  <Link to="/audit-&-compliance">Audit & Compliance</Link>
                </div>
              </div>
              <p className="service-two__single-text">
                VAPT Services, Security audit and guidance in implementing regulatory compilance solutions
              </p>
              <div className="service-two__read-more">
                <Link to="/audit-&-compliance">Read more<span className="icon-dubble-arrow-right"></span></Link>
              </div>
            </div>
          </div>
          {/* Services Two Single End */}

          {/* Services Two Single Start */}
          <div className="col-xl-4 col-lg-4 wow fadeInRight" data-wow-delay="500ms">
            <div className="service-two__single">
              <div className="service-two__icon-and-title">
                <div className="service-two__icon">
                  <span className="icon-hook"></span>
                </div>
                <div className="service-two__title">
                  <Link to="/cloud-security">Cloud Security</Link>
                </div>
              </div>
              <p className="service-two__single-text">
               Manage, optimize and enhance cloud efficiency, storage & databases access to software
              </p>
              <div className="service-two__read-more">
                <Link to="/cloud-security">Read more<span className="icon-dubble-arrow-right"></span></Link>
              </div>
            </div>
          </div>
          {/* Services Two Single End */}
        </div>
      </div>
    </section>
  );
};

export default ServiceTwo;
